<template>
  <!-- <el-dialog
    class="dialogModel"
    width="40%"
    :visible.sync="dialogVisibleImgTwo"
    title="上传视频"
    custom-class="dialog_box"
    :close-on-click-modal="false"
  > -->
  <el-form
    :model="formInfo"
    :rules="rules"
    ref="ruleForm"
    label-width="100px"
    class="formVideoInfo"
    label-position="top"
  >
    <!--  label-position="top" -->
    <el-form-item label="视频标题：" prop="title">
      <el-input v-model="formInfo.title" placeholder="请输入视频标题" />
    </el-form-item>
    <el-form-item label="作者：" prop="author">
      <el-input v-model="formInfo.author" placeholder="请输入作者" />
    </el-form-item>
    <el-form-item label="年份" prop="video_create_time">
      <el-date-picker
        v-model="formInfo.video_create_time"
        type="year"
        style="width: 100%"
        value-format="yyyy"
        placeholder="请选择年份"
      >
      </el-date-picker>
    </el-form-item>
    <!-- <el-form-item label="封面图：" prop="cover_img">
        <el-upload
          :http-request="uploadpic"
          class="avatar-uploader"
          action=""
          :show-file-list="false"
        >
          <div v-if="!isShowCover_img">
            <img
              v-if="formInfo.cover_img"
              :src="formInfo.cover_img"
              class="avatar wow bounceInU"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </div>
          <div v-else>
            <el-progress
              :width="85"
              type="circle"
              :percentage="progressPercentCover_img"
            ></el-progress>
          </div>
        </el-upload>
      </el-form-item> -->
    <el-form-item label="视频文件：" prop="video_url">
      <div class="file_path_info">
        <el-upload
          :http-request="uploadfile"
          :before-upload="beforeUpload"
          class="avatar-uploader"
          action=""
          :show-file-list="false"
        >
          <div v-if="!isShowfile_path">
            <img
              v-if="formInfo.video_url"
              src="../assets/image/uploadfile.jpg"
              class="avatar wow bounceInU"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </div>
          <div v-else>
            <el-progress
              :width="85"
              type="circle"
              :percentage="progressPercentfile_path"
            ></el-progress>
          </div>
        </el-upload>
        <span class="red_font">
          （请上传mp4、avi、flv、mpg、asf、wmv、mov、rmvb、rm、3gp格式文件）
        </span>
      </div>
    </el-form-item>
    <el-form-item label="视频介绍：" prop="remarks">
      <TinyMceEditor v-model="formInfo.remarks" placeholder="请输入视频介绍" />
    </el-form-item>
    <el-form-item class="btn_item">
      <el-button class="btn_info" @click="okClick"> 提交 </el-button>
    </el-form-item>
  </el-form>
  <!-- </el-dialog> -->
</template>
<script>
import TinyMceEditor from "./TinyMCE.vue";
import videoApi from "../api/popularScienceVideo";
import { getuser } from "../api/user";
import {
  setVideoForm,
  getVideoForm,
  clearVideoForm,
} from "../utils/localstore";
import { sevenCloud } from "../api/createCenter";
import * as qiniu from "qiniu-js";
export default {
  name: "videoAddEdit",
  props: {
    dialogVisibleImg: {
      type: Boolean,
      default: false,
    },
    _id: {
      type: Number,
      default: 0,
    },
    type: {
      type: String,
      default: "list",
    },
  },
  data() {
    return {
      dialogVisibleImgTwo: false,
      videoID: null,
      formInfo: {
        title: "",
        author: "",
        video_url: "",
        cover_img: "",
        remarks: "",
        video_create_time: "",
      },
      rules: {
        title: [{ required: true, message: "视频标题必填", trigger: "change" }],
        author: [{ required: true, message: "作者必填", trigger: "change" }],
        video_create_time: [
          { required: true, message: "年份必填", trigger: "change" },
        ],
        video_url: [
          { required: true, message: "视频文件必填", trigger: "change" },
        ],
        remarks: [
          { required: true, message: "视频介绍必填", trigger: "change" },
        ],
      },
      // 视频地址
      isShowfile_path: false,
      progressPercentfile_path: 0,
      config: {},
      // 视频封面
      isShowCover_img: false,
      progressPercentCover_img: 0,
    };
  },
  created() {
    let videoForm = getVideoForm();
    console.log(videoForm, "videoForm");
    if (videoForm.title) {
      this.formInfo = JSON.parse(videoForm);
    }
  },
  watch: {
    _id: {
      handler(val) {
        // console.log(val, "valvalval");
        if (val) {
          this.videoDetail(val);
        }
        this.videoID = val;
      },
      deep: true,
      immediate: true,
    },
    dialogVisibleImg: {
      handler(val) {
        // console.log(val, "dialogVisibleImg");
        // this.dialogVisibleImgTwo = val;
      },
      deep: true,
    },
    // dialogVisibleImgTwo: {
    //   handler(val) {
    //     // console.log(val, "valdialogVisibleImg", this);
    //     // $listeners
    //     this.$listeners.close_click(val);
    //     if (!val) {
    //       this.formInfo = {
    //         title: "",
    //         author: "",
    //         video_url: "",
    //         cover_img: "",
    //         remarks: "",
    //       };
    //       if (this.$refs && this.$refs.ruleForm) {
    //         this.$refs.ruleForm.resetFields();
    //       }
    //     }
    //   },
    //   deep: true,
    //   immediate: true,
    // },
  },
  methods: {
    uploadfile(el) {
      this.isShowfile_path = true;
      this.upload(el, "video_url");
    },
    uploadpic(el) {
      this.isShowCover_img = true;
      this.upload(el, "cover_img");
    },
    beforeUpload(rawFile) {
      console.log(rawFile, "rawFile");
      let name = rawFile.name;
      let suffix = name.split(".")[name.split(".").length - 1];
      // if (rawFile.type.includes("video")) {
      //   return true;
      // } else
      if (
        suffix.toLowerCase() == "flv" ||
        suffix.toLowerCase() === "rmvb" ||
        suffix.toLowerCase() === "avi" ||
        suffix.toLowerCase() === "mp4" ||
        suffix.toLowerCase() === "mpg" ||
        suffix.toLowerCase() === "asf" ||
        suffix.toLowerCase() === "wmv" ||
        suffix.toLowerCase() === "mov" ||
        suffix.toLowerCase() === "rm" ||
        suffix.toLowerCase() === "3gp"
      ) {
        return true;
      } else {
        this.$message.error(
          "请上传mp4、avi、flv、mpg、asf、wmv、mov、rmvb、rm、3gp格式的视频文件"
        );
        return false;
      }
    },
    async upload(el, code) {
      try {
        await this.getsevencload();
        const that = this;
        const observable = qiniu.upload(
          el.file,
          el.file.name,
          this.config.token
        );
        const observer = {
          next(res) {
            //上传图片
            if (code === "cover_img") {
              that.progressPercentCover_img = 0;
              that.progressPercentCover_img = Math.trunc(
                Number(((res.total.loaded / res.total.size) * 100).toFixed(2))
              );
            }
            //预览文件
            if (code === "preview_path") {
              that.progressPercentpreview_path = 0;
              that.progressPercentpreview_path = Math.trunc(
                Number(((res.total.loaded / res.total.size) * 100).toFixed(2))
              );
            }
            //上传文件
            if (code === "video_url") {
              // that.formInfo.video_url = Math.round(res.total.size / 1024) + "kB";
              that.progressPercentfile_path = 0;
              that.progressPercentfile_path = Math.trunc(
                Number(((res.total.loaded / res.total.size) * 100).toFixed(2))
              );
            }
          },
          error(err) {
            console.log("失败了吗", err);
            that.$message.error("上传失败");
          },
          complete(res) {
            that.formInfo[code] = that.config.cdn + res.key;
            that.animation();
            that.$message.success("文件上传成功");
          },
        };
        observable.subscribe(observer);
      } catch (error) {
        console.log(error, "upload");
      }
    },
    okClick() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          let data = JSON.parse(JSON.stringify(this.formInfo));
          console.log(data);
          if (data.id) {
            this.videoEdit(data);
          } else {
            this.videoUpload(data);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    animation() {
      this.$nextTick(() => {
        new this.$wow.WOW({
          boxClass: "wow",
          animateClass: "animated",
          offset: 0,
          mobile: true,
          live: true,
        }).init();
        this.isShowCover_img = false; //上传图片进度条
        // this.isShowpreview_path = false; //预览文件
        this.isShowfile_path = false; //上传文件
        this.$refs.form.validateField("cover_img"); //上传图片后对表单从新验证
        this.$refs.form.validateField("preview_path"); //预览文件对表单从新验证
        this.$refs.form.validateField("video_url"); //上传文件后对表单从新验证
      });
    },
    /**
     * 上传视频
     * @param data
     */
    async videoUpload(data) {
      let dataNew = {
        title: data.title,
        author: data.author,
        video_url: data.video_url,
        cover_img: data.cover_img,
        remarks: data.remarks,
        video_create_time: data.video_create_time,
      };
      try {
        let res = await videoApi.videoUpload(dataNew);
        if (res.code == 1) {
          clearVideoForm();
          this.$emit("success_Click");
          this.$message.success("上传成功");
          // this.$emit("close_click");
          // this.formInfo = {
          //   title: "",
          //   author: "",
          //   video_url: "",
          //   cover_img: "",
          //   remarks: "",
          // };
          this.$refs.ruleForm.resetFields();
        } else if (res.msg == "请先通过认证") {
          setVideoForm(this.formInfo);
          this.$emit("close_click", {
            type: "certification",
            title: "温馨提示",
            content:
              "账号需要认证审核通过后上传视频，如果其它问题请联系项目组！",
          });
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * 查看视频详情
     * @param id
     */
    async videoDetail(id) {
      try {
        let res = await videoApi.myVideoDetail(id);
        if (res.code == 1) {
          // console.log(res, "res");
          this.formInfo = res.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * 修改视频--
     * @param data
     */
    async videoEdit(data) {
      let dataNew = {
        id: data.id,
        title: data.title,
        author: data.author,
        video_url: data.video_url,
        cover_img: data.cover_img,
        remarks: data.remarks,
        video_create_time: data.video_create_time,
      };
      try {
        let res = await videoApi.myVideoEdit(dataNew);
        if (res.code == 1) {
          this.$emit("success_Click");
          this.$message.success("修改成功");
          // this.$emit("close_click");
          // this.dialogVisibleImgTwo = false;
          // this.formInfo = {
          //   title: "",
          //   author: "",
          //   video_url: "",
          //   cover_img: "",
          //   remarks: "",
          // };
          this.$refs.ruleForm.resetFields();
        } else {
          if (res.msg === "修改失败") {
            // this.dialogVisibleImgTwo = false;
            // this.formInfo = {
            //   title: "",
            //   author: "",
            //   video_url: "",
            //   cover_img: "",
            //   remarks: "",
            // };
            // this.$refs.ruleForm.resetFields();
            this.$message.error(res.msg);
          } else if (res.msg == "请先通过认证") {
          } else {
            this.$message.error(res.msg);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getsevencload() {
      try {
        const res = await sevenCloud();
        if (res.code === 1) {
          this.config = res.data;
          return Promise.resolve();
        } else {
          return Promise.reject(res);
        }
      } catch (error) {
        console.log(error, "getsevencload");
        return Promise.reject(error);
      }
    },
    async getuserAsync() {
      try {
        let res = await getuser();
        if (res.code == 1) {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res);
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  components: {
    TinyMceEditor,
  },
};
</script>
<style scoped lang="less">
.formVideoInfo {
  // max-height: 680px;
  // max-height: 730px;
  // overflow: auto;
}
// .el-form-item {
//   display: flex;
//   /deep/ .el-form-item__label {
//     min-width: 100px;
//   }
//   /deep/ .el-form-item__content {
//     flex: 1;
//   }
// }
.avatar-uploader /deep/.el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 85px;
  height: 48px;
  line-height: 48px;
  text-align: center;
}
.avatar {
  width: 85px;
  height: 48px;
  display: block;
}
.dialogModel {
  /deep/ .dialog_box {
    border-radius: 10px;
    overflow: hidden;
    margin-top: 4vh !important;
  }
  /deep/ .el-dialog__header {
    background: linear-gradient(180deg, #dbf8ff 0%, #ffffff 100%);
  }
}
.btn_item {
  text-align: center;
}
.btn_info:hover {
  color: #fff !important;
}
.btn_info {
  width: 90px;
  height: 40px;
  background: linear-gradient(136deg, #2fd2c1 0%, #4888fc 100%);
  color: #fff;
  /deep/ span {
    font-size: 17px;
  }
}
</style>
